import styled from 'styled-components'
import InnerPageContainer from '../../../../components/layout/private/inner-page-container.component'
import { BLUE, GRAY, MEDIUMGRAY } from '../../../../styles/colors.style'
import Browser from '../../../../services/Browser'
import { breakpoints } from '../../../../constants'

const handleActiveColor = ({ isActive }) => (isActive ? BLUE : GRAY)

export const StyledButton = styled.div`
	text-align: center;
	color: ${handleActiveColor};
	border: 1px solid ${handleActiveColor};
	padding: 1rem;
	height: 100px;
	width: calc(50% - 22.5px);
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	@media screen and (min-width: ${breakpoints.PHONE_LARGE + 1}px) {
		width: 150px;
	}

	&:hover {
		color: ${BLUE};
		border-color: ${BLUE};
		cursor: pointer;
	}
`

export const StyledPointsPurchasePage = styled(InnerPageContainer)`
	.whose-points {
		font-size: 20px;
		display: flex;
		margin-bottom: 4rem;
		justify-content: center;

		@media screen and (min-width: ${breakpoints.PHONE_LARGE + 1}px) {
			justify-content: space-around;
		}

		& > div {
			width: ${Browser.isIE() ? '100%' : null};
		}
	}

	.cpf {
		font-size: 3.6rem;
		color: ${MEDIUMGRAY};
		display: ${Browser.isIE() ? 'flex' : 'grid'};
		grid-gap: 4rem 15px;
		align-items: end;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			grid-template-columns: 1fr 1fr;
		}

		& > * {
			margin-right: ${Browser.isIE() ? '15px' : null};
		}
	}
`

export const StyledForm = styled.div`
	display: ${Browser.isIE() ? 'flex' : 'grid'};
	flex-direction: column;
	grid-gap: 4rem 15px;

	& > * {
		margin-bottom: ${Browser.isIE() ? '4rem' : null};
	}

	.buy-points {
		display: flex;
		flex-direction: column;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			flex-direction: row;
			justify-content: space-between;

			& > * {
				flex: 1;
			}

			& > *:not(:first-child) {
				text-align: center;
			}
		}

		.points-info {
			@media screen and (min-width: ${breakpoints.MOBILE}px) {
				width: 200%;
			}

			&.mTop {
				margin-top: 5rem;
			}
		}
		
		.value {
			color: ${MEDIUMGRAY};
			font-size: 3.6rem;
			margin-bottom: 1.3rem;

			@media screen and (min-width: ${breakpoints.MOBILE}px) {
				margin-bottom: initial;
			}
		}

		.label {
			font-size: 15px;
			margin-bottom: 7px;
		}
	}

	.address-section {
		display: flex;
		flex-direction: column;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			flex-direction: row;
			justify-content: space-between;
			align-items: flex-end;
		}
	}

	.payment-resume-container {
		margin-bottom: 30px;
		padding-bottom: 5px;
		border-bottom: 1px solid #999;

		.description-discounts {
			display: flex;
			width: 100%;
			justify-content: space-between;
			margin: 0;

			.descrip, .descrip-value {
				display: flex;
			}
		}

		.value {
			font-weight: bolder;
			margin-bottom: 5px;
		}

		.label-boleto {
			display: flex;
			justify-content: flex-end;
			margin-top: 10px;
		}
	}
`

export const ieMediaQueryCleanReset870 = `
	@media screen and (max-width: 870px) {
		margin-left: 0px;
	}
`

export const ieMediaQueryClear = `
	@media screen and (min-width: 870px) {
		margin-left: 0px;
	}
`

export const ieStyle = `
	display: flex;
	flex-wrap: wrap;
	justify-content: space-around;
	& > div {
		width: 205px;
		margin-bottom: 25px;
	}
`
